export default "__VITE_ASSET__CdoChjRM__"